import React from 'react'
import { styled } from '@creditas/stylitas'
import { useTranslation } from 'react-i18next'

const Container = styled.div`
  position: absolute;
  right: 0;
  top: 6px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  text-align: right;
`

const AssignmentDate: React.FC<{ date: Date | null }> = ({
  date: assignmentDate,
}) => {
  const { t } = useTranslation(['assignments'])
  return (
    <Container>
      <p>{t('card.assignment-date.description')}</p>
      <p>
        {t('card.assignment-date.date-formatted', {
          date: assignmentDate,
        })}
      </p>
    </Container>
  )
}

export { AssignmentDate }
